<template>
    <div></div>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'

export default {
    // props: {
    //   license: {
    //     required: true,
    //     type: Number
    //   },
    //   group: {
    //     required: true,
    //     type: Number
    //   }
    // },

    data: () => {
        return {}
    },
    computed: {
        ...mapGetters(['getAllState']),
    },
    mounted() {
        if (this.$store.getters['auth/isImpersonated']) {
            return
        }

        this.$http.get('services/tickets/user').then(res => {
            let user = res.data[0]
            let auth_user = this.$store.getters['auth/user']

            let visitor = {
                name: user.fullName,
                email: user.id + '@ikomm.no',
            }
            let params = [
                { name: 'Email', value: auth_user.email },
                { name: 'Company', value: auth_user.company.name },
                { name: 'Department', value: auth_user.department.name },
                { name: 'Role', value: auth_user.role.name },
            ]
            let cfg = config.services.livechatinc

            window.__lc = window.__lc || {}
            window.__lc.license = cfg.licence
            window.__lc.group = cfg.group
            window.__lc.visitor = visitor
            window.__lc.params = params

            let script = document.createElement('script')

            script.type = 'text/javascript'
            script.src = '//cdn.livechatinc.com/tracking.js'
            script.async = true

            let lc_api = {}
            // console.log('script', script)

            script.onload = () => {
                lc_api.on_after_load = () => {
                    // console.log('lc_api.on_after_load', res)
                    lc_api.set_visitor_email(visitor.email)
                    lc_api.set_visitor_name(visitor.name)
                    lc_api.set_custom_variables(params)
                    lc_api.on_message = () => {
                        if (!lc_api.chat_window_hidden()) {
                            lc_api.show_full_view()
                        }
                    }
                }

                // Assign to windows
                window.LC_API = lc_api
            }
            document.body.appendChild(script)
        })
    },

    created() {},

    loadLiveChat() {},
}
</script>

<style></style>
